import { css } from '@acko-tech/building-blocks.ui.common';

export const dialog = css`
    & .muidialog-paper {
        border-radius: ${(props: any) => props.theme.borderRadius * 4};
    }

    & .MuiDialogContent-root:first-child {
        width: 520px;
        padding: ${(props: any) => props.theme.spacing(5)};
    }
`;

export const label = css`
    color: #000;
`;

export const closeIcon = css`
    position: absolute;
    right: ${(props: any) => props.theme.spacing(2.5)};
    top: ${(props: any) => props.theme.spacing(2.5)};
    cursor: pointer;
`;
